export { default } from './PromptTriggerRule';
